































































































































import { Component, Vue } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { IAuthService, RecoveryResponse, IInvitationService } from '@/interfaces/Services';
import Axios from 'axios';
import { passwordRules, fullNameRules, emailRules, required } from '@/utils/validation';
import { UserModel } from '@/models/user';
import LambdaDownloader from '@/utils/lambda_downloader';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

enum Pages {
  Agreements = 1,
  Password = 2,
  Confirmation = 3,
}

@Component({})
export default class SignupCard extends Vue {
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;
  @inject(DependencyIdentifiers.InvitationService)
  private invitationService!: IInvitationService;

  private Pages = Pages;

  private step = 1;
  private isLoading = false;
  private confirmationDialog = false;
  private isRegisteredUser = false;
  private registeredUser?: UserModel;
  private token: string = "";
  private formData = {
    registrationCode: "",
    hasAgreedTermsAndConditions: false,
    hasAgreedToPrivacyPolicy: false,
    hasAgreedToReceiveMarketingMessages: true,
    password: ""
  };

  private visibility = {
    password: false,
    confirmPassword: false
  };
  private get formConfig() {
    return {
      registrationCode: {
        label: this.$t('account.recoveryKey'),
        rules: [
          (v: string | undefined) =>
            !!v || `${this.$t('validator.required')}. ${this.$t('account.signup.recoveryKeyHint')}.`
        ],
        hint: this.$t('account.signup.recoveryKeyHint')
      },
      hasAgreedTermsAndConditions: {
        label: this.$t('account.signup.eula.hint'),
        rules: [
          (v: boolean | undefined) =>
            !!v || this.$t('account.signup.eula.required')
        ]
      },
      hasAgreedToPrivacyPolicy: {
        label: this.$t('account.signup.privacyPolicy.hint'),
        rules: [
          (v: boolean | undefined) =>
            !!v || this.$t('account.signup.privacyPolicy.required')
        ]
      },
      hasAgreedToReceiveMarketingMessages: {
        label: this.$t('account.signup.aggreedMarketingAccess')
      },
      password: {
        label: this.$t('account.password'),
        rules: [required, ...passwordRules],
      },
      confirmPassword: {
        label: this.$t('account.passwordConfirm'),
        rules: [
          required,
          (v: string | undefined) =>
            (v && v === this.formData.password) || this.$t("validator.passwordMismatch")
        ],
      }
    };
  }

  mounted() {
    if (!this.$route.query.token) {
      this.$router.push({path:'/'})
      return;
    }
    this.token = this.$route.query.token.toString();
  }

  async next() {
    const form = this.$refs[`form[${this.step}]`];
    // @ts-ignore
    if (form && !form.validate()) {
      return;
    }

    switch (this.step) {
      case Pages.Agreements:
        this.isLoading = true;
        let verify = false;
        try {
          verify = await this.invitationService.verify(this.token, this.formData.registrationCode);
        } finally {
          this.isLoading = false;
        }

        if (!verify) {
          alert(this.$t('account.signup.errorInvalidCode'));
          break;
        }

        this.step++;
        break;
      case Pages.Password:
        this.isLoading = true;
        try {
          this.registeredUser = await this.authService.register(
            this.token,
            this.formData.registrationCode,
            this.formData.password
          );

          this.isRegisteredUser = true;
          this.step++;
        } catch (e) {
          alert(this.$t('account.signup.errorUnknown'));
        }
        this.isLoading = false;
        break;
      default:
        this.step++;
    }
  }

  async download() {
    if (this.isLoading) {
      return;
    }

    const key = this.registeredUser!.recoveryKey!;
    const email = this.registeredUser!.name!;
    const download = new LambdaDownloader(
      {key, email },
      'recovery-key-to-pdf',
      `hemonaplo-recovery-${email}`,
      (isLoading) => this.isLoading = isLoading,
    );
    await download.start();
  }
}
